import JQueryView, { on } from '../../../../common/views/jqueryView';
import $ from 'jquery';

export default class ShowView extends JQueryView {
  constructor() {
    super('#fundraising_sim');
  }

  @on({ event: 'click', selector: '#scroll-button' })
  onClickScrollButton() {
    const offset = $('#simulator').offset()?.top;

    if (offset !== undefined) {
      $('html, body').animate({ scrollTop: offset }, 600);
    }
  }
}
